import React, { Component } from 'react';
import { Row, Col, Button, Alert } from 'reactstrap';
import { withLocale } from '@dietlabs/components';
import { reportWarning } from '@dietlabs/utils';
import withGTM from 'view/GoogleTagManager/withGTM';
import { EVENT_CATEGORY_DIET_PLAN } from 'view/GoogleTagManager/EventCategories';
import PropTypes from 'prop-types';
import Loader from 'Layout/Loader';
import { holidayIcons } from 'consts';

import start from 'assets/images/dayplan/start.jpg';
import breakfast from 'assets/images/dayplan/breakfast.jpg';
import dinner from 'assets/images/dayplan/dinner.jpg';
import snack from 'assets/images/dayplan/snack.jpg';
import supper from 'assets/images/dayplan/supper.jpg';

import { callNativeAppRemoveLastRoute } from 'components/Helpers/callNativeAppRemoveLastRoute';
import { scrollToTop } from 'components/Helpers/scrollToTop';

class DayPlanDayReplacement extends Component {
    static propTypes = {
        trackEvent: PropTypes.func.isRequired,
        dayReplacement: PropTypes.shape({
            active: PropTypes.bool.isRequired,
            dietSetId: PropTypes.number.isRequired,
            events: PropTypes.array, //eslint-disable-line
            holiday: PropTypes.object, //eslint-disable-line
            categories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
        }).isRequired,
        search: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
        replaceDay: PropTypes.shape().isRequired,
        toggleModalWithDayReplacements: PropTypes.func.isRequired,
    };

    state = {
        preloadOutside: false,
    };

    changeDay = async () => {
        this.props.trackEvent(EVENT_CATEGORY_DIET_PLAN, 'exchange day');

        const replacement = {
            replacementId: this.props.dayReplacement.dietSetId,
        };

        this.setState({ preloadOutside: true });

        await this.props.replaceDay.replace(replacement);

        if (
            this.props.replaceDay.response.me.dietSetReplace.__typename ===
            'BasicMutationSuccess'
        ) {
            this.setState({ preloadOutside: false });
            this.props.toggleModalWithDayReplacements();
            window.onpopstate = () => {};
            window.history.go(-1);
            callNativeAppRemoveLastRoute('diet');
            setTimeout(() => {
                scrollToTop();
            }, 1000);
        } else {
            throw new Error(
                `Replace day failed: ${this.props.replaceDay.response.me.dietSetReplace.__typename}`
            );
        }
    };

    renderDietPhase() {
        if (
            this.props.dayReplacement.categories &&
            this.props.dayReplacement.categories[0]
        ) {
            const fastType = this.props.dayReplacement.categories[0].name.toLowerCase();
            return (
                <div className="diet-phase fast mb-3">
                    {this.props.t('fast')} {fastType}
                </div>
            );
        }

        return '';
    }

    renderMealImage = (mealName, preparationImageUrl) => {
        let mealImg;

        if (preparationImageUrl) {
            mealImg = preparationImageUrl;
        } else {
            switch (mealName) {
                case 'Start':
                    mealImg = start;
                    break;
                case 'Śniadanie':
                    mealImg = breakfast;
                    break;
                case 'Obiad':
                    mealImg = dinner;
                    break;
                case 'Przekąska':
                    mealImg = snack;
                    break;
                case 'Kolacja':
                    mealImg = supper;
                    break;
                default:
                    mealImg = breakfast;
            }
        }

        return (
            <>
                <div className="embed-responsive embed-responsive-1by1 d-md-none">
                    <div
                        style={{
                            backgroundImage: `url(${mealImg})`,
                        }}
                        className="embed-responsive-item"
                    />
                </div>

                <div className="embed-responsive embed-responsive-4by3 d-none d-md-block">
                    <div
                        style={{
                            backgroundImage: `url(${mealImg})`,
                        }}
                        className="embed-responsive-item"
                    />
                </div>
            </>
        );
    };

    renderReplacment() {
        const dayReplacement = this.props.dayReplacement;
        const mealsOnly = dayReplacement.events.filter(
            event => event.__typename === 'Meal'
        );

        return (
            <Row
                className={
                    dayReplacement.active
                        ? 'align-items-center'
                        : 'align-items-center not-active'
                }
            >
                <Col xs="12">
                    {this.props.dayReplacement.holiday ? (
                        <h2 className="text-center mb-3">
                            {this.renderHolidayIcon()}
                        </h2>
                    ) : (
                        ''
                    )}

                    <div className="text-md-center">
                        {this.renderDietPhase()}
                    </div>

                    {mealsOnly.map(event => {
                        let i = 0;
                        return (
                            <div className="event-meal" key={event.id}>
                                <Row>
                                    <Col xs="3" md="4">
                                        {this.renderMealImage(
                                            event.name,
                                            event.preparationImageUrl
                                        )}
                                    </Col>
                                    <Col xs="9" md="8">
                                        <div>
                                            <strong>{event.name}</strong>{' '}
                                            <span> - </span>
                                            <ul className="list-of-dishes">
                                                {event.dishes.map(dish => {
                                                    i += 1;
                                                    return (
                                                        <li key={dish.id}>
                                                            {i >= 2 ? ', ' : ''}
                                                            {dish.name}
                                                            {dish.ingredients
                                                                ? dish.ingredients.map(
                                                                      ingredient => {
                                                                          if (
                                                                              ingredient.name.toLowerCase() ===
                                                                              this.props.search.toLowerCase()
                                                                          ) {
                                                                              return (
                                                                                  <strong
                                                                                      key={
                                                                                          ingredient.productId
                                                                                      }
                                                                                  >
                                                                                      {' '}
                                                                                      (
                                                                                      {this.props.t(
                                                                                          'meal/menus-contain'
                                                                                      )}{' '}
                                                                                      {this.props.search.toLowerCase()}

                                                                                      ){' '}
                                                                                  </strong>
                                                                              );
                                                                          }

                                                                          return '';
                                                                      }
                                                                  )
                                                                : ''}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                </Col>
                <Col
                    xs={{ size: 10, offset: 1 }}
                    md={{ size: 6, offset: 3 }}
                    className="text-center"
                >
                    <Button
                        color="secondary"
                        size="sm"
                        data-test="button-replace-day"
                        onClick={async () => this.changeDay()}
                        className="mt-3 w-100"
                        disabled={!dayReplacement.active}
                    >
                        {this.props.t('meal/exchange-dish-button')}
                    </Button>
                </Col>
                {!dayReplacement.active ? (
                    <Col xs="12" className="mt-4">
                        <Alert color="danger">
                            {this.props.t('fast/exchange-day/alert')}
                        </Alert>
                    </Col>
                ) : (
                    ''
                )}
                {this.state.preloadOutside ? <Loader /> : ''}
            </Row>
        );
    }

    renderHolidayIcon() {
        const Icon = holidayIcons[this.props.dayReplacement.holiday.icon];
        if (Icon) {
            return (
                <span className="SVGInline primary">
                    <Icon />
                </span>
            );
        }

        reportWarning(
            new Error(
                `Unknown holiday icon${this.props.dayReplacement.holiday.icon}`
            )
        );
        return '';
    }

    render() {
        return (
            <Col md="6">
                <div
                    className={
                        this.props.dayReplacement.holiday
                            ? 'white-box holiday'
                            : 'white-box'
                    }
                >
                    {this.renderReplacment()}
                </div>
            </Col>
        );
    }
}
export { DayPlanDayReplacement };
export default withGTM(withLocale(DayPlanDayReplacement));
